import React, { useState } from 'react';
import DatePicker from "react-datepicker";
import moment from "moment";

const StartDatePickerComponent = ({ column, dispatch, value, rowData }) => {

    const [selectedDate, setSelectedDate] = useState(value || moment().toDate());

    const handleDatePickerChange = async (date) => {
        setSelectedDate(date);
        dispatch({
            type: 'UpdateCellValue',
            rowKeyValue: rowData.rxf_id,
            columnKey: column.key,
            value: date,
            cellComponentType: 'StartDatePicker'
        });
    };

    return (
        <div>
            <span className="inline-block">
                <DatePicker
                    placeholderText="MM/DD/YYYY"
                    selected={selectedDate}
                    minDate={value || moment().toDate()}
                    onChange={(date) => {
                        handleDatePickerChange(date)
                    }}

                    className="border focus:outline-none h-11 rounded-md pl-2 text-sm font-normal w-full"
                />
            </span>
        </div>
    );
};

export default StartDatePickerComponent;